<template>
<BaseTemplate>
  <div class="base">
    <Title :jpn="t('登録情報設定')"></Title>
    <div class="link_area">
      <div class="link" @click="goToChangeMember">本人情報</div>
      <div class="link" @click="goToTransferPoint">ポイント移行</div>
      <div class="link" @click="goToChangePassword">パスワード変更</div>
    </div>
    <div class="button_area">
      <BlackGradationButton
        class="square-button"
        :text="t('戻る')"
        @handleSquareBtnClick="goToBack"
      />
    </div>
  </div>
</BaseTemplate>
</template>

<script>
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import Title from '@/components/molecules/Title.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import t from '@/plugins/i18n';

export default {
  mixins: [t],

  components: {
    BaseTemplate,
    Title,
    BlackGradationButton,
  },

  methods: {
    goToBack() {
      this.$router.push('./my-page');
    },
    goToChangeMember() {
      this.$router.push('./change-member');
    },
    goToChangePassword() {
      this.$router.push('./change-password');
    },
    goToTransferPoint() {
      this.$router.push('./transfer-point');
    },
  },
};
</script>

<style lang="scss" scoped>
.base {
  min-height: calc(100vh - 303px);
  padding-top: 30px;
  padding-bottom: 50px;
  max-width: 600px;
  margin: auto;
  .link_area {
    margin: 40px 0;
    .link {
      border-top: solid 1px $black;
      padding: 15px 0 15px 20px;
      color: $black;
      cursor: pointer;
      transition: .4s;
      &:hover {
        background-color: $black;
        color: $white;
      }
      &:nth-child(3) {
        border-bottom: solid 1px $black;
      }
    }
  }
  .button_area {
    display: flex;
    justify-content: center;
    align-items: center;
    .square-button {
      max-width: 200px;
      width: 100%;
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .base {
    .link_area {
      padding: 0 10px;
      .link {
        &:hover {
          background-color: $white;
          color: $black;
        }
        &:active {
          background-color: $black;
          color: $white;
        }
      }
    }
  }
}
</style>
